export default {
  backgroundBase: '#ffffff',
  backgroundMemorial: '#1F2C4E',
};



// WEBPACK FOOTER //
// ./src/app/utils/themeColors.js